function getDomain(altMethod) {
  if(altMethod) return getEmbeddingDomain()
  let domain = "";
  // console.log(window)
  try {
    // Attempt to read the parent domain
    domain = window.top.location.hostname;
  } catch (error) {
    // If there's a cross-origin error, fall back to the iframe's own domain
    domain = window.location.hostname;
  }

  return domain;
}

function getEmbeddingDomain() {
  const ref = document.referrer;
  if (ref) {
    try {
      return new URL(ref).hostname;   // e.g. "client-site.com"
    } catch (e) {
      // malformed referrer
    }
  }
  // nothing in referrer or parse failed
  return window.location.hostname;   // your own domain
}


export default getDomain;
